/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 19V7.35797C9 6.45276 9 6.00015 9.15937 5.6252C9.29996 5.29443 9.52709 5.00766 9.81686 4.79505C10.1453 4.55404 10.5859 4.45037 11.4671 4.24304L17.0671 2.9254C18.4099 2.60943 19.0813 2.45145 19.6091 2.62022C20.0718 2.76817 20.4648 3.07945 20.7148 3.49596C21 3.97108 21 4.66083 21 6.04033V13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9 19.0001C9 20.657 7.65685 22.0001 6 22.0001C4.34315 22.0001 3 20.657 3 19.0001C3 17.3433 4.34315 16.0001 6 16.0001C7.65685 16.0001 9 17.3433 9 19.0001ZM9 19.0001V13.0001M21 10.0001V16.0001M21 16.0001C21 17.657 19.6569 19.0001 18 19.0001C16.3431 19.0001 15 17.657 15 16.0001C15 14.3433 16.3431 13.0001 18 13.0001C19.6569 13.0001 21 14.3433 21 16.0001Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M9 19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16C7.65685 16 9 17.3431 9 19Z"
					fill="currentColor"
				/>
				<path
					d="M21 16C21 17.6569 19.6569 19 18 19C16.3431 19 15 17.6569 15 16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M9 19V7.35797C9 6.45276 9 6.00015 9.15937 5.6252C9.29996 5.29443 9.52709 5.00766 9.81686 4.79505C10.1453 4.55404 10.5859 4.45037 11.4671 4.24304L17.0671 2.9254C18.4099 2.60943 19.0813 2.45145 19.6091 2.62022C20.0718 2.76817 20.4648 3.07945 20.7148 3.49596C21 3.97108 21 4.66083 21 6.04033V16M9 19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16C7.65685 16 9 17.3431 9 19ZM21 16C21 17.6569 19.6569 19 18 19C16.3431 19 15 17.6569 15 16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.2389 3.65551C17.9236 3.49439 18.3894 3.38549 18.7507 3.33342C19.1062 3.28218 19.2745 3.3007 19.3807 3.33464C19.6699 3.42711 19.9155 3.62166 20.0718 3.88198C20.1291 3.97754 20.1857 4.13718 20.2173 4.49493C20.2493 4.85854 20.25 5.33694 20.25 6.04038V12.9998C19.6233 12.529 18.8442 12.2501 18 12.2501C15.9289 12.2501 14.25 13.929 14.25 16.0001C14.25 18.0711 15.9289 19.7501 18 19.7501C20.0711 19.7501 21.75 18.0711 21.75 16.0001V6.04038V6.00608C21.75 5.34549 21.75 4.80055 21.7115 4.36318C21.6717 3.9124 21.5857 3.4896 21.3579 3.11005C21.0142 2.53735 20.4737 2.10933 19.8375 1.9059C19.4159 1.77108 18.9846 1.7842 18.5367 1.84876C18.1022 1.9114 17.5717 2.03622 16.9286 2.18754L16.8953 2.19538L11.2953 3.51303L11.2698 3.51904C10.8509 3.61758 10.4979 3.70063 10.2103 3.79083C9.90781 3.88569 9.62957 4.00229 9.37319 4.19041C8.97475 4.48275 8.66245 4.87706 8.46913 5.33187C8.34474 5.62453 8.29496 5.92207 8.27191 6.23824C8.24998 6.53888 8.24999 6.90151 8.25 7.33179V7.35803V15.9998C7.62325 15.529 6.8442 15.2501 6 15.2501C3.92893 15.2501 2.25 16.929 2.25 19.0001C2.25 21.0711 3.92893 22.7501 6 22.7501C8.07107 22.7501 9.75 21.0711 9.75 19.0001V7.35803C9.75 6.89461 9.75046 6.58695 9.76793 6.34734C9.78472 6.11716 9.81463 6.00093 9.84961 5.91864C9.93748 5.71191 10.0794 5.53268 10.2605 5.39979C10.3326 5.3469 10.4389 5.29116 10.6591 5.2221C10.8884 5.15021 11.1878 5.0793 11.6389 4.97316L17.2389 3.65551Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9 19V7.35797C9 6.45276 9 6.00015 9.15937 5.6252C9.29996 5.29443 9.52709 5.00766 9.81686 4.79505C10.1453 4.55404 10.5859 4.45037 11.4671 4.24304L12 4.11765L13 3.88235M9 19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16C7.65685 16 9 17.3431 9 19ZM17 2.94118L18 2.70588V2.70588C18.4906 2.59045 18.7359 2.53273 18.9351 2.52626C19.9115 2.49455 20.7679 3.17286 20.9607 4.13056C21 4.32592 21 4.57792 21 5.08193V16C21 17.6569 19.6569 19 18 19C16.3431 19 15 17.6569 15 16C15 14.3431 16.3431 13 18 13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 19V7.35797C9 6.45276 9 6.00015 9.15937 5.6252C9.29996 5.29443 9.52709 5.00766 9.81686 4.79505C10.1453 4.55404 10.5859 4.45037 11.4671 4.24304L17.0671 2.9254C18.4099 2.60943 19.0813 2.45145 19.6091 2.62022C20.0718 2.76817 20.4648 3.07945 20.7148 3.49596C21 3.97108 21 4.66083 21 6.04033V16M9 19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16C7.65685 16 9 17.3431 9 19ZM21 16C21 17.6569 19.6569 19 18 19C16.3431 19 15 17.6569 15 16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.7507 3.33342C18.3894 3.38549 17.9236 3.49439 17.2389 3.65551L11.6389 4.97316C11.1878 5.0793 10.8884 5.15021 10.6591 5.2221C10.4389 5.29116 10.3326 5.3469 10.2605 5.39979C10.0794 5.53268 9.93748 5.71191 9.84961 5.91864C9.81463 6.00093 9.78472 6.11716 9.76794 6.34734C9.75046 6.58695 9.75 6.89461 9.75 7.35803V19.0001C9.75 19.4143 9.41421 19.7501 9 19.7501C8.58579 19.7501 8.25 19.4143 8.25 19.0001V7.35803L8.25 7.33179C8.24999 6.90151 8.24998 6.53888 8.27191 6.23824C8.29497 5.92207 8.34474 5.62453 8.46913 5.33187C8.66245 4.87706 8.97475 4.48275 9.37319 4.19041C9.62958 4.00229 9.90781 3.88569 10.2103 3.79083C10.4979 3.70063 10.8509 3.61758 11.2698 3.51904L11.2953 3.51303L16.8953 2.19538L16.9286 2.18754C17.5717 2.03622 18.1022 1.9114 18.5367 1.84876C18.9846 1.7842 19.4159 1.77108 19.8375 1.9059C20.4737 2.10933 21.0142 2.53735 21.3579 3.11005C21.5857 3.4896 21.6717 3.9124 21.7115 4.36318C21.75 4.80056 21.75 5.34551 21.75 6.00613V6.04038V16.0001C21.75 16.4143 21.4142 16.7501 21 16.7501C20.5858 16.7501 20.25 16.4143 20.25 16.0001V6.04038C20.25 5.33694 20.2493 4.85854 20.2173 4.49493C20.1857 4.13718 20.1291 3.97754 20.0718 3.88198C19.9155 3.62166 19.6699 3.42711 19.3807 3.33464C19.2745 3.3007 19.1062 3.28218 18.7507 3.33342Z"
				fill="currentColor"
			/>
			<path
				d="M18 12.2501C15.9289 12.2501 14.25 13.9291 14.25 16.0001C14.25 18.0712 15.9289 19.7501 18 19.7501C20.0711 19.7501 21.75 18.0712 21.75 16.0001C21.75 13.9291 20.0711 12.2501 18 12.2501Z"
				fill="currentColor"
			/>
			<path
				d="M6 15.2501C3.92893 15.2501 2.25 16.9291 2.25 19.0001C2.25 21.0712 3.92893 22.7501 6 22.7501C8.07107 22.7501 9.75 21.0712 9.75 19.0001C9.75 16.9291 8.07107 15.2501 6 15.2501Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
